import colors from "assets/theme/base/colors";
import { CHART_COLORS } from "utils/designTokens";

export const getProductMentionVolumeChartOptions = (categories) => ({

  chart: {
    width: "100%",
    height: 350,
    type: "area",
    toolbar: {
      show: false,
    },
  },
  tooltip: {
    theme: "dark",
    y: {
      formatter: function(val) {
        return (val !== undefined && val !== null ? String(val) : "0") + " mentions";
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
    width: 3,
  },
  xaxis: {
    type: "category",
    categories: categories,
    labels: {
      style: {
        colors: "#c8cfca",
        fontSize: "12px",
      },
      formatter: function(val) {
        try {
          const date = new Date(val);
          return date.toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric'
          });
        } catch (e) {
          return val;
        }
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: true,
    labels: {
      style: {
        colors: "#c8cfca",
        fontSize: "12px",
      },
      formatter: function(val) {
        return val.toFixed(0);
      },
    },
    title: {
      text: "Mention Volume",
      rotate: -90,
      offsetX: 12,
      style: {
        color: "#c8cfca",
        fontSize: "12px",
        fontFamily: "Sora",
        fontWeight: "normal",
      },
    },
  },
  legend: {
    show: true,
    position: "top",
    horizontalAlign: "right",
    labels: {
      colors: "#c8cfca",
    },
    markers: {
      width: 10,
      height: 10,
      radius: 5,
    },
    itemMargin: {
      horizontal: 10,
      vertical: 5
    },
  },
  grid: {
    strokeDashArray: 5,
    borderColor: "#56577A",
    xaxis: {
      lines: {
        show: true,
      },
    },
    yaxis: {
      lines: {
        show: true,
      },
    },
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "vertical",
      shadeIntensity: 0.5,
      gradientToColors: undefined, // Optional: end colors of the gradient
      inverseColors: false,
      opacityFrom: 0.8,
      opacityTo: 0.1,
      stops: [0, 90, 100]
    }
  },
  colors: CHART_COLORS,
});

export const getTopMentionedProductsChartOptions = (categories) => ({
  chart: {
    width: "100%",
    height: 350,
    type: "bar",
    toolbar: {
      show: false,
    },
  },
  tooltip: {
    theme: "dark",
    y: {
      formatter: function(val) {
        return val + " mentions";
      },
    },
  },
  plotOptions: {
    bar: {
      borderRadius: 4,
      horizontal: false,
      columnWidth: "50%",
      dataLabels: {
        position: "top",
      },
    },
  },
  dataLabels: {
    enabled: true,
    offsetY: -20,
    style: {
      fontSize: "12px",
      colors: ["#fff"],
    },
    formatter: function(val) {
      return val.toFixed(0);
    },
  },
  xaxis: {
    categories: categories,
    labels: {
      style: {
        colors: "#c8cfca",
        fontSize: "12px",
      },
      rotate: -45,
      trim: false,
      maxHeight: 120,
      formatter: function(value) {
        if (typeof value !== "string" || value.trim() === "") {
          return value;
        }
        const originalWords = value.split(" ");

        // Filter out purely numeric words for the count
        const nonNumericWords = originalWords.filter(word => !(/^\s*-?\d+(\.\d+)?\s*$/).test(word.trim()));

        if (nonNumericWords.length > 2) {
          // Return the first two *original* words if more than 2 non-numeric words
          return originalWords.slice(0, 2).join(" ");
        } else {
          // Otherwise, explicitly rejoin the original words to ensure a new string reference
          return originalWords.join(" ");
        }
      },
    },
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    title: {
      text: "Total Mentions",
      offsetX: 12,
      rotate: -90,
      style: {
        color: "#c8cfca",
        fontSize: "12px",
        fontFamily: "Sora",
        fontWeight: "normal",
      },
    },
    labels: {
      style: {
        colors: "#c8cfca",
        fontSize: "12px",
      },
      formatter: function(val) {
        return val.toFixed(0);
      },
    },
  },
  grid: {
    strokeDashArray: 5,
    borderColor: "#56577A",
    yaxis: {
      lines: {
        show: true,
      },
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "vertical",
      shadeIntensity: 0.5,
      gradientToColors: [colors.info.main, colors.info.focus],
      inverseColors: true,
      opacityFrom: 0.8,
      opacityTo: 0.2,
      stops: [0, 100],
    },
  },
  colors: [colors.info.main],
}); 